import { Medal, Award, HeartHandshake, Star, Users, Trophy } from "lucide-react";
import { honors } from "@/data/profile";

const icons = { Medal, Award, HeartHandshake, Star, Users, Trophy };

export const Honors = () => (
  <section className="section" id="honors">
    <div className="container">
      <p className="eyebrow">06 · Honors & Awards</p>
      <h2 className="section-title">Recognition earned through service</h2>
      <div className="honors-grid" data-testid="honors-grid">
        {honors.map((h, i) => {
          const Icon = icons[h.icon];
          return (
            <article className={`honor-card ${i === 0 ? "honor-featured" : ""}`} key={h.id} data-testid={h.testId}>
              <div className="honor-icon">
                <Icon size={22} />
              </div>
              <span className="honor-date">{h.date}</span>
              <h3 className="honor-title">{h.title}</h3>
              <p className="honor-subtitle">{h.subtitle}</p>
              <p className="honor-issuer">{h.issuer} · {h.date}</p>
              <p className="honor-desc">{h.description}</p>
            </article>
          );
        })}
      </div>
    </div>
  </section>
);
